import { createRef } from 'react';
import clsx from 'clsx';
import Link from '@/components/Link';
import Image from '@/components/Image';
import useHover from '@/hooks/useHover';

export default function Partner({
  uri,
  title,
  featuredImage,
  excerpt,
}) {
  const target = createRef();
  const isHovering = useHover(target);

  return (
    <Link ref={target} href={uri} className="w-full transition ease-in-out duration-300 rounded-xl border hover:border-transparent relative bg-white">
      <div className="flex items-start w-full px-6 py-6 lg:py-8 space-x-6 rounded-xl">
        <div>
          <Image
            className={clsx(
              'w-16 h-16 rounded-full shadow transition ease-in-out duration-300 transform',
              isHovering === false && 'scale-100',
              isHovering === true && 'scale-75',
            )}
            alt={title}
            src={featuredImage.node.sourceUrl}
            srcSet={featuredImage.node.srcSet}
          />
        </div>
        <div className="flex-1 flex flex-col space-y-2">
          <h3 className="text-lg font-medium">
            {title}
          </h3>
          {(excerpt !== null) && (
            <div
              className="text-gray-500 text-base leading-6"
              dangerouslySetInnerHTML={{ __html: excerpt }}
            />
          )}
        </div>
      </div>
      <div
        className={clsx(
          'absolute inset-0 shadow-outside rounded-lg transform transition ease-in-out duration-300',
          isHovering === false && 'opacity-0 scale-90',
          isHovering === true && 'opacity-100 scale-100',
        )}
      />
    </Link>
  );
}
